"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _useGoogleSignInButton = _interopRequireDefault(require("web/shared/hooks/useGoogleSignInButton"));
var _GoogleSignInButtonFrame = require("web/shared/components/GoogleSignInButtonFrame.styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* Where Google's own sign-in button is drawn, and the line under it that
* says why sign-in did not go through. The button stays beside a failed
* credential, so "please try again" can be acted on; only a button that
* could not be set up at all gives way to the line alone. What a product
* does with the credential stays in its own button.
*
* The line is always there, empty until it has something to say, because a
* live region present before its text changes is what a screen reader
* announces reliably. Empty, it takes no room.
*/
function GoogleSignInButtonFrame(props) {
  var _props$credentialErro;
  const _useGoogleSignInButto = (0, _useGoogleSignInButton.default)(props.onCredential, props.appearance),
    containerRef = _useGoogleSignInButto.containerRef,
    mountError = _useGoogleSignInButto.error;
  const error = (_props$credentialErro = props.credentialError) !== null && _props$credentialErro !== void 0 ? _props$credentialErro : mountError;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_GoogleSignInButtonFrame.styles.frame)), {}, {
    children: [mountError == null ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)({
      ref: containerRef
    }, stylex.props(_GoogleSignInButtonFrame.styles.button, props.appearance.scale === "roomy" && _GoogleSignInButtonFrame.styles.roomy))) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({
      role: "status"
    }, stylex.props(_GoogleSignInButtonFrame.styles.feedback)), {}, {
      children: error !== null && error !== void 0 ? error : ""
    }))]
  }));
}
var _default = exports.default = GoogleSignInButtonFrame;